import React, { memo } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "next-i18next";
import { SEARCH_TABLE_PAGE_SIZE_OPTIONS } from "src/components/pages/search/components/table/consts";
import { SearchTable } from "src/components/pages/search/components/table/search-table";
import { ISearchTableProps } from "src/components/pages/search/components/table/search-table.types";

type ISearchTableResultsProps = Pick<
    ISearchTableProps,
    "data" | "rowCount" | "isLoading" | "sorting" | "onSortingChange" | "pagination" | "onPaginationChange" | "figures"
>;

const SearchTableResultsComponent = (props: ISearchTableResultsProps) => {
    const { t } = useTranslation("common");

    return (
        <Box sx={{ isolation: "isolate" }}>
            <SearchTable {...props} pageSizeOptions={SEARCH_TABLE_PAGE_SIZE_OPTIONS} itemsLabel={t("wikifolios")} />
        </Box>
    );
};

export const SearchTableResults = memo(SearchTableResultsComponent);
